export { default as NAffix, affixProps } from './src/Affix';
